import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setupI18n } from './i18n';
import './styles.css';

// The language loads first: the rest of the app is imported after it, so labels built when a
// module loads already come out in the person's language.
const language = await setupI18n();
// The installed app's description and shortcuts follow the person's language.
if (language !== 'es') {
  document.getElementById('manifest')?.setAttribute('href', `${import.meta.env.BASE_URL}manifest-${language}.webmanifest`);
}
const [{ App }, { AuthProvider }, { fitNumbers }, { applyScreenColors, readScreenColors }] = await Promise.all([
  import('./App'),
  import('./state/auth'),
  import('./fitNumbers'),
  import('./screenColors'),
]);

applyScreenColors(readScreenColors());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

fitNumbers();

// The service worker caches only the application shell. Authenticated API
// responses are never cached: stale table or ticket state would be worse than
// no state at all, and drafts already live in local storage.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`);
  });
}
